// extracted by mini-css-extract-plugin
module.exports = {"IndustryLeadingE":"IndustryLeadingE_IndustryLeadingE__pdg_v"};